<template>
  <div class="hs-code-root">
    <section class="hs-code__section">
      <div class="hs-code__container">
        <h1 class="hs-code__heading">{{ $t("HS Code Finder") }}</h1>

        <div class="hs-code__description">
          {{
            $t("Find the appropriate HS code for your international shipment.")
          }}
        </div>

        <h2 class="hs-code__section-heading">{{ $t("Search by keyword") }}</h2>

        <hs-search :language="language" />

        <p class="hs-code__small-text hs-code__hint-text">
          {{
            $t(
              "Tip: If you can't find what you're looking for, try searching for the materials your product is made of, or use the navigator below."
            )
          }}
        </p>

        <slot />

        <small class="hs-codes__data-source">
          {{ $t("Data Source:") }}
          <a :href="source" class="hs-code__link" target="_blank">
            {{ $t("Official Journal of the European Union") }}
          </a>
          , {{ $t("Published:") }} {{ date }}
        </small>

        <p class="hs-code__small-text">{{ $t(`disclaimer-text`) }}</p>
      </div>
    </section>
    <!-- Uncomment, if you will need the gating form back -->
    <!-- <hs-code-modal
      v-if="showSignUpModal"
      @toggle="(show) => (showSignUpModal = show)"
    /> -->
  </div>
</template>

<script>
import HSSearch from "@/components/HSCodes/HSSearch.vue";
// import HSCodeModal from "@/components/HSCodes/HSCodeModal.vue";
import { getCurrentLanguage } from "@/lang/i18n.js";

export default {
  name: "HSCodeLayout",
  watch: {
    $route() {
      this.checkIfShouldSignup();
    },
  },
  data() {
    return {
      language: getCurrentLanguage(),
      date: "19-10-2019",
      showSignUpModal: false,
      source:
        "http://publications.europa.eu/resource/cellar/4fdaf64e-fc25-11e9-8c1f-01aa75ed71a1.0006.01/DOC_1",
    };
  },
  mounted() {
    this.checkIfShouldSignup();
  },
  components: {
    "hs-search": HSSearch,
    // "hs-code-modal": HSCodeModal,
  },
  methods: {
    checkIfShouldSignup() {
      const numberOfTimesUsed = parseInt(
        localStorage.getItem("numberOfTimesUsed")
      );
      const hasSignedUp = localStorage.getItem("signedUp") === "true";

      if (numberOfTimesUsed >= 3 && !hasSignedUp) {
        this.showSignUpModal = true;
      }
    },
  },
};
</script>

<style>
.hs-code-root {
  display: flex;
  flex-direction: column;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  color: #122857;
}
.hs-code__section {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  margin: px 0px 0px;
  padding: 30px;
}

.hs-code__container {
  max-width: 800px;
}

.hs-code__heading {
  margin: 0px 0px 15px 0px;
  font-weight: 800;
  font-size: 1.9em;
  line-height: 30px;
  text-align: center;
}

.hs-codes__data-source {
  display: inline-block;
  line-height: 1.5em;
  color: #2c3e50;
  margin-bottom: 15px;
}

.hs-code__table {
  color: #122857 !important;
  margin-bottom: 30px !important;
}

.hs-code__section-heading {
  font-size: 1.35em;
  text-align: left;
  margin: 30px 0px;
  font-weight: 700;
}

.hs-code__subheading {
  font-size: 1.25em;
  text-align: left;
  margin: 30px 0px;
  font-weight: 700;
}

.hs-code__section-index {
  background: #122857;
  padding: 0px 7.5px;
  color: white;
  border-radius: 5px;
  font-size: 0.9em;
  margin-right: 5px;
}

.hs-code__description {
  margin: 0px 0px 0px 0px;
  font-size: 16px;
  text-align: center;
}

.hs-code__small-text {
  line-height: 1.5em;
  font-size: 0.8em;
  color: #2c3e50;
}
.hs-code__hint-text {
  line-height: 1.5em;
  color: #2c3e50;
  margin-bottom: 15px;
}

.hs-code__code-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0px 0px 0px 1px;
  padding: 15px;
  border-bottom: 1px solid #f1f1f1;
}
.hs-code__code-description-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  min-height: 68px;
  margin: 0px 0px 0px 1px;
  padding: 20px;
  background: transparent;
}
.hs-code__text {
  font-weight: 800;
  font-size: 1.5em;
  line-height: 1em;
  background: none;
  color: inherit;
  border: none;
  max-width: 50%;
}
.hs-code__text:focus {
  outline: none !important;
}
.hs-code__button {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 200px;
  min-height: 30px;
  margin: 0px 0px 0px 10px;
  padding: 4px 8px;
  background: rgb(18, 40, 87);
  border: none;
  border-radius: 5px;
  transition: background 0.25s ease-in-out;
  font-size: 16px;
  color: white;
}

.hs-code__copy-icon {
  margin: 0px 5px 0px 0px;
  font-size: 0.9em;
}
.hs-code__code-heading {
  margin: 10px 0px 5px 0px;
  font-size: 1.1em;
  font-weight: 600;
  line-height: 1.1em;
}
.hs-code__code-description {
  margin: 0px 0px 5px;
  font-size: 0.9em;
}

@media screen and (min-width: 576px) {
  .hs-code-root {
    font-size: 16.5px;
  }
  .hs-code__section {
    padding: 45px 30px;
  }
}
@media screen and (min-width: 768px) {
  .hs-code__input-field {
    height: 50px;
  }
  .hs-code__section {
    align-items: center;
  }
  .hs-code__disclaimer-text {
    max-width: 750px;
  }
}
@media screen and (min-width: 992px) {
  .hs-code__card {
    align-self: center;
  }
  .hs-code__search-box {
    align-self: center;
  }
}
@media screen and (min-width: 1200px) {
  .hs-code__disclaimer-text {
    width: 750px;
  }
}

.hs-code__table {
  min-height: 275px;
}

.hs-code__table tbody tr {
  transition: box-shadow 0.15s;
}

.hs-code__table tbody tr:hover {
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.15);
}
</style>
